<form #addCrmForm [class.submitted]="addCrmForm.submitted" (ngSubmit)="submit()" class="w-100 add-crm-form" novalidate>
  <div class="add-crm-body">
    <div class="form-group d-flex flex-row align-items-end">
      <div class="flex-grow-1">
        <label for="company" class="add-crm-label">{{ "GENERICS.COMPANY" | translate }}<sup *ngIf="!item.nonDeal" class="red">*</sup>
          <rms-required-label *ngIf="!item.nonDeal" [formFieldReference]="companyRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <ng-select [(ngModel)]="item.companies[0].company"
                   [items]="companyList"
                   [multiple]="false"
                   [typeahead]="companyTypeahead"
                   [loading]="companySearching"
                   bindLabel="name" name="company" id="company" #companyRef [required]="!item.nonDeal">
        </ng-select>
        <div *ngIf="companyError" class="error">{{ companyError }}</div>
      </div>
      <div *ngIf="!(inputCompanyId || inputCrmItem)" class="d-flex mt-3 ml-3">
        <div class="new-company-button align-content-center" (click)="addCompany()">{{ "CRM.ADD_CRM_MODAL.NEW_RMS_COMPANY"| translate }}</div>
      </div>
    </div>

    <div class="d-flex flex-row w-100">
      <div class="form-group flex-grow-1">
        <label for="crm-name" class="add-crm-label">{{ "CRM.ADD_CRM_MODAL.STRUCT_CAP_DEAL_NAME" | translate }}<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="nameRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <input id="crm-name" name="crm-name" class="form-control" [(ngModel)]="item.name" #nameRef required />
      </div>
      <div *ngIf="!inputCrmItem" class="form-group checkbox d-flex flex-column justify-content-center ml-3">
        <input id="deal-checkbox" name="deal-checkbox" type="checkbox" class="checkbox" [(ngModel)]="item.nonDeal" />
        <label for="deal-checkbox" class="non-deal-label">Non-Deal</label>
      </div>
    </div>

    <div class="d-flex flex-row w-100">
      <div class="form-group flex-grow-1">
        <label for="crm-summary" class="add-crm-label">{{ "CRM.ADD_CRM_MODAL.STRUCT_CAP_DEAL_SUMMARY" | translate }} ({{ "GENERICS.MAX_CHARACTERS" | translate:{value: 200} }})<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="summaryRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <input id="crm-summary" name="crm-summary" class="form-control" maxlength="200" [(ngModel)]="item.summary" #summaryRef required />
      </div>

      <div class="col-4 pl-3 pr-0">
        <label for="healthcare-sub-sector" class="add-crm-label">{{ "CRM.ADD_CRM_MODAL.HEALTHCARE_SUB_SECTOR" | translate }}<sup *ngIf="!item.nonDeal" class="red">*</sup>
          <rms-required-label *ngIf="!item.nonDeal" [formFieldReference]="summaryRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <ng-select [(ngModel)]="item.healthcareSubSector" name="healthcare-sub-sector" id="healthcare-sub-sector" [items]="healthcareSubsectorSelectOptions"
                   bindValue="key" bindLabel="name" [required]="!item.nonDeal">
        </ng-select>
      </div>
    </div>

    <div class="form-group d-flex">
      <div style="width: 53%" class="pr-2 row-item" *ngIf="!item.nonDeal">
        <label for="status" class="add-crm-label">{{ "CRM.ADD_CRM_MODAL.STRUCT_CAP_STATUS" | translate}}<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="statusRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <ng-select [(ngModel)]="item.status" name="status" id="status" #statusRef [items]="statusSelectOptions" [clearable]="false" class="status-dropdown"
                   bindValue="key" bindLabel="name" required>
        </ng-select>
      </div>

      <div style="width: 9%" class="pr-1 row-item">
        <label for="priority">{{ "CRM.ADD_CRM_MODAL.PRIORITY" | translate }}<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="priorityRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <input type="number" id="priority" name="priority" class="form-control" #priorityRef [(ngModel)]="item.priority" (ngModelChange)="updatePriorityHint($event)" min="1" step=".1" required />
      </div>

      <div style="width: 19%" class="pl-1 row-item" *ngIf="!item.nonDeal">
        <label for="ra-deal-size">{{ "CRM.ADD_CRM_MODAL.RA_DEAL_SIZE" | translate }} ($M)<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="raDealSizeRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <input type="number" id="ra-deal-size" name="ra-deal-size" class="form-control" #raDealSizeRef [(ngModel)]="item.raDealSize" min="0" step="any" required />
      </div>

      <div style="width: 19%" class="px-1 row-item" *ngIf="!item.nonDeal">
        <label for="deal-size">{{ "CRM.ADD_CRM_MODAL.DEAL_SIZE" | translate }} ($M)<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="totalDealSizeRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <input type="number" id="deal-size" name="deal-size" class="form-control" #totalDealSizeRef [(ngModel)]="item.totalDealSize" min="0" step="any" required />
      </div>
    </div>

    <div class="priority-hint">
      <ng-container [ngSwitch]="priorityHint.state">
        <span *ngSwitchCase="'exact'"><b>{{ priorityHint.value }} · {{ priorityHint.tier.label }}</b></span>
        <span *ngSwitchCase="'between'"><b>{{ priorityHint.value }}</b> {{ "CRM.STRUCT_CAP.PRIORITY_HINT.BETWEEN" | translate: {
          lower: priorityHint.lower.value, lowerLabel: priorityHint.lower.label, upper: priorityHint.upper.value, upperLabel: priorityHint.upper.label
        } }}</span>
        <span *ngSwitchCase="'outOfRange'" [innerHTML]="'CRM.STRUCT_CAP.PRIORITY_HINT.OUT_OF_RANGE' | translate"></span>
        <span *ngSwitchDefault [innerHTML]="'CRM.STRUCT_CAP.PRIORITY_HINT.EMPTY' | translate"></span>
      </ng-container>
      <button type="button" class="priority-hint-toggle" (click)="showAllPriorityTiers = !showAllPriorityTiers" [attr.aria-expanded]="showAllPriorityTiers">
        {{ (showAllPriorityTiers ? "CRM.STRUCT_CAP.PRIORITY_HINT.HIDE_TIERS" : "CRM.STRUCT_CAP.PRIORITY_HINT.ALL_TIERS") | translate }}
        <i class="fa" [ngClass]="showAllPriorityTiers ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
      </button>
      <div class="priority-hint-tiers" *ngIf="showAllPriorityTiers">
        <div class="priority-tier" *ngFor="let tier of priorityTiers" [class.current]="tier.value === priorityHint.nearestTier">
          <span class="priority-tier-num">{{ tier.value }}</span><span class="priority-tier-label">{{ tier.label }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="showSilenceUntil()" class="form-group row ml-0">
      <div style="width: 58%" class="row-item">
        <div class="input-group">
          <rms-date-picker id="silenceUntilDate"
                           name="silenceUntilDate"
                           #silenceUntilDateRef="ngModel"
                           [(ngModel)]="silenceUntilDate"
                           [placeholder]="'Date for Reactivation'"
                           [isRange]="false"
                           required>
          </rms-date-picker>
          <sup class="red pt-2">*</sup>
        </div>
      </div>
    </div>

    <div class="form-group row" *ngIf="!item.nonDeal">
      <div class="pr-2 col-8 row-item">
        <label for="deal-type" class="add-crm-label">{{ "CRM.ADD_CRM_MODAL.DEAL_TYPE" | translate }}<sup class="red">*</sup>
          <rms-required-label [formFieldReference]="dealRef" [componentForm]="addCrmForm"></rms-required-label>
        </label>
        <ng-select [(ngModel)]="item.dealTypes" name="deal-type" id="deal-type" #dealRef="ngModel"
                   [multiple]="true" bindValue="key" bindLabel="name" required>
          <ng-option *ngFor="let dealType of dealTypeSelectOptions" [value]="dealType">
            {{ DealTypeLabels[dealType] }}
          </ng-option>
        </ng-select>
      </div>
      <div class="pl-1 col-4 row-item">
        <label for="source-contact">{{ "CRM.ADD_CRM_MODAL.SOURCE_CONTACT" | translate }}</label>
        <input id="source-contact" name="source-contact" class="form-control" [(ngModel)]="item.dealSourceContact" />
      </div>
    </div>

    <div class="form-group row">
      <div class="col-5 pr-2">
        <rms-crm-user-select [(ngModel)]="item.leader" [label]="(!item.nonDeal ? 'Deal ' : '') + 'Lead'" [multiple]="false" [required]="true" [clearable]="false" name="deal-lead"></rms-crm-user-select>
      </div>
      <div class="col-7 pl-1">
        <rms-crm-user-select [(ngModel)]="item.participants" [label]="(!item.nonDeal ? 'Deal ' : '') + 'Team'" [multiple]="true" [required]="false" name="deal-team"></rms-crm-user-select>
      </div>
    </div>

    <div class="d-flex flex-row w-100">
      <div class="form-group flex-grow-1">
        <label for="crm-next-steps" class="add-crm-label">{{ "CRM.STRUCT_CAP.NEXT_STEPS" | translate }}</label>
        <textarea id="crm-next-steps" name="crm-next-steps" class="form-control" [(ngModel)]="item.nextSteps"></textarea>
      </div>
    </div>

    <div class="form-group" *ngIf="!item.nonDeal">
      <label for="description">{{ "CRM.ADD_CRM_MODAL.DESCRIPTION" | translate }}</label>
      <textarea id="description" name="description" class="form-control" rows="3" [(ngModel)]="item.description"></textarea>
    </div>

    <div class="form-group row" *ngIf="!item.nonDeal">
      <div class="pr-2 col-6">
        <rms-crm-user-select [(ngModel)]="item.sourceUsers" [label]="'Sourced By'" [multiple]="true" [required]="false" name="sourced-by"></rms-crm-user-select>
      </div>
      <div class="pl-1 col-6">
        <label for="source-type">{{ "CRM.ADD_CRM_MODAL.SOURCE_TYPE" | translate }}</label>
        <ng-select [(ngModel)]="item.dealSourceType" name="source-type" id="source-type"
                   bindValue="key" bindLabel="name">
          <ng-option *ngFor="let sourceType of dealSourceTypeSelectOptions" [value]="sourceType">
            {{ DealSourceTypeLabels[sourceType] }}
          </ng-option>
        </ng-select>
      </div>
    </div>

    <a href="javascript:void(0)" class="more-details-button d-block pt-3 mt-4 mb-2" (click)="moreDetails = !moreDetails" *ngIf="!item.nonDeal">More Details <i class="fa" [ngClass]="moreDetails ? 'fa-angle-up' : 'fa-angle-down'"></i></a>

    <div *ngIf="moreDetails" class="more-details-container">
      <div class="form-group row">
        <div class="col-6">
          <label for="company-stage" class="add-crm-label">{{ "CRM.ADD_CRM_MODAL.COMPANY_STAGE" | translate }}
          </label>
          <ng-select [(ngModel)]="item.companyStage" name="company-stage" id="company-stage" [items]="companyStageSelectOptions"
                     bindValue="key" bindLabel="name">
          </ng-select>
        </div>

        <div class="col-6">
          <label for="location">{{ "CRM.ADD_CRM_MODAL.LOCATION" | translate }}</label>
          <input id="location" name="location" class="form-control" [(ngModel)]="item.location" placeholder="Location of the company or asset" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          <label for="focus">{{ "CRM.ADD_CRM_MODAL.DISEASE_FOCUS" | translate }}</label>
          <input id="focus" name="focus" class="form-control" [(ngModel)]="item.diseaseFocus" placeholder="Oncology, cardiology, etc." />
        </div>

        <div class="col-6">
          <label for="cap-iq">{{ "CRM.ADD_CRM_MODAL.CAP_IQ" | translate }}</label>
          <input id="cap-iq" name="cap-iq" class="form-control" [(ngModel)]="item.capIqId" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          <label for="closing-date">{{ "CRM.ADD_CRM_MODAL.CLOSING_DATE" | translate }}</label>

          <div class="d-flex">
            <rms-date-picker class="flex-grow-1"
                             id="closing-date"
                             name="closing-date"
                             #closingDateRef="ngModel"
                             [(ngModel)]="closingDate"
                             [placeholder]="'Anticipated date of deal closure'"
                             [isRange]="false">
            </rms-date-picker>
          </div>
        </div>

        <div class="col-6 d-flex align-items-center">
          <div class="checkbox mr-3 nda-checkbox">
            <input id="nda-signed" name="nda-signed" type="checkbox" [(ngModel)]="item.ndaSigned" />
            <label for="nda-signed">{{ "CRM.ADD_CRM_MODAL.NDA_SIGNED" | translate }}</label>
          </div>
          <div *ngIf="item.ndaSigned">
            <label for="closing-date">{{ "CRM.ADD_CRM_MODAL.NDA_EXPIRATION" | translate }}</label>

            <div class="d-flex">
              <rms-date-picker id="ndaDate"
                               name="ndaDate"
                               #ndaDateRef="ngModel"
                               [(ngModel)]="ndaDate"
                               [isRange]="false">
              </rms-date-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          <label for="revenue-model">{{ "CRM.ADD_CRM_MODAL.REVENUE_MODEL" | translate }}</label>
          <input id="revenue-model" name="revenue-model" class="form-control" [(ngModel)]="item.revenueModel" placeholder="Revenue model or primary source of cash flow" />
        </div>

        <div class="col-6">
          <label for="collateral">{{ "CRM.ADD_CRM_MODAL.COLLATERAL_TYPE" | translate }}</label>
          <input id="collateral" name="collateral" class="form-control" [(ngModel)]="item.downsideSupport" placeholder="Type of collateral/downside protection" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          <label for="ltm-revenue">{{ "CRM.ADD_CRM_MODAL.LTM_REVENUE" | translate }}</label>
          <input id="ltm-revenue" name="ltm-revenue" type="number" class="form-control" [(ngModel)]="item.ltmRevenue" />
        </div>

        <div class="col-6">
          <label for="ltm-ebitda">{{ "CRM.ADD_CRM_MODAL.LTM_EBITDA" | translate }}</label>
          <input id="ltm-ebitda" name="ltm-ebitda" type="number" class="form-control" [(ngModel)]="item.ltmEbitda" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          <label for="expected-irr">{{ "CRM.ADD_CRM_MODAL.EXPECTED_IRR" | translate }} (%)</label>
          <input id="expected-irr" name="expected-irr" type="number" class="form-control" [(ngModel)]="item.expectedIrr" placeholder="Project internal rate of return" />
        </div>

        <div class="col-6">
          <label for="expected-moic">{{ "CRM.ADD_CRM_MODAL.EXPECTED_MOIC" | translate }}</label>
          <input id="expected-moic" name="expected-moic" type="number" class="form-control" [(ngModel)]="item.expectedMoic" placeholder="Expected multiple on invested capital" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          <label for="pre-money-valuation">{{ "CRM.ADD_CRM_MODAL.PRE_MONEY_VALUATION" | translate }} ($M)</label>
          <input id="pre-money-valuation" name="pre-money-valuation" type="number" class="form-control" [(ngModel)]="item.currentRoundValuation" placeholder="Pre-money valuation" />
        </div>

        <div class="col-6">
          <label for="post-money-valuation">{{ "CRM.ADD_CRM_MODAL.POST_MONEY_VALUATION" | translate }} ($M)</label>
          <input id="post-money-valuation" name="post-money-valuation" type="number" class="form-control" [(ngModel)]="item.lastRoundValuation" placeholder="Post-money valuation" />
        </div>
      </div>
    </div>
  </div>

  <ng-content></ng-content>
</form>
